import React, { useEffect } from "react";
import CustomersReview from "./CustomersReview";
import IntialPage from "./IntialPage";
import OurWellness from "./OurWellness";
import WellnessProgram from "./WellnessProgram";
import Choose from "./Choose";
import './corporate.css';
import Footer from '../Home/Footer'
import Header from '../Home/Navbar'




const CorporateLandingPage = () => {


  return (
    <>
      <Header/>
      <IntialPage />
      <OurWellness />
      <Choose/>
      <WellnessProgram />
      <CustomersReview />
      <Footer />
    </>
  );
};

export default CorporateLandingPage;
